import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import pinia from '@/store/pinia'
import mixins from '@/mixins'
import NioUI from '@ui'
import Swiper from 'vue-awesome-swiper'
import VConsole from 'vconsole'
import { isMobile, getEnv ,getQueryString} from '@common/utils'
import {  globalErrorCatch,createApmInstance } from '@/utils/apms-tool'
import { createHead } from '@unhead/vue'



import '@/assets/css/style.scss'
import 'swiper/css/swiper.css'

const env = getEnv()

// // 注入vconsole方便ipad调试
env !== 'prod' && new VConsole()
// 移动端跳转h5链接
if (isMobile()) {
  const vehicle = location.href.match(/(\/configurator\/)(\w+)/);
  let car = vehicle[2]||'ES7';
  let newVersion = getQueryString('newVersion',window.location) || '';
  const envMap = {
    'dev': '-sit',
    'test': '-sit',
    'stg': '-stg',
    'prod': ''
  }
 location.href = `https://configh5${envMap[env]}.nio.com/car-config/version${vehicle? ('?type=' + car): ''}${newVersion?('&newVersion='+newVersion):''}`
}
const redirectUrl =  getQueryString('redirectUrl',window.location)
if(redirectUrl){
  window.location.replace(decodeURIComponent(redirectUrl))
}


import { initTrack } from '@common/utils/track'

const applySwiperSafetyPatch = () => {
  const swiperComponent = Vue?.options?.components?.Swiper
  const deleteInstanceProp =
    swiperComponent?.options?.props?.deleteInstanceOnDestroy
  if (!deleteInstanceProp) return
  // APM wraps listeners globally; keep swiper instance fields to avoid stale touchmove callback crash.
  deleteInstanceProp.default = false
}

// 合并全局mixins
Vue.mixin(mixins)

// 注册全局组件
Vue.use(NioUI).use(Swiper).use(createHead())
applySwiperSafetyPatch()

new Vue({
  el: '#app',
  pinia,
  router,
  render: (h) => h(App)
})
globalErrorCatch()
createApmInstance()
initTrack()
